module.exports = __webpack_public_path__ + "img/Wassergefälle.b2d2ce90.jpg";